import moduleSettings from '../Utils/settings.js'

class Spotlight {
	constructor(opts, el) {
		this.el = el
		this.options = opts
		this.spotlights = this.el.querySelectorAll('.SpotlightsBlock-item')
		this.indicator = this.el.querySelector('.SpotlightsBlock-indicator')
		this.active = -1
		this.spotWidth = this.spotlights[0].offsetWidth
		this.timer = null
		this.paused = false
		this.ada_liveregion = null
		this.init()
	}

	init() {
		this.spotlights.forEach((spotlight, idx) => {
			// click listener
			spotlight.addEventListener('click', () => {
				this.paused = true
				this.setActive(idx)
			})
			// focus listener. this is mainly for screen readers and keyboard navigation
			spotlight.querySelector('.content').addEventListener('focus', () => {
                this.paused = true
			})
			// keyboard navigation
			spotlight.querySelector('.content').addEventListener('keyup', (e) => {
				const { keyCode } = e
				// if the user presses left or right, we want to either go to the previous spotlight or the last one if we're on the first one, or go to the next spotlight or the first one if we're on the last one
				if (keyCode === 37 || keyCode === 39) {
                    this.paused = true
                    let idx = this.active
                    if (keyCode === 37) {
                        idx = idx === 0 ? this.spotlights.length - 1 : idx - 1
                    } else {
                        idx = idx === this.spotlights.length - 1 ? 0 : idx + 1
					}
					this.spotlights[idx].querySelector('.content').focus()
                    this.setActive(idx)
                }
			})
		})

		// set a function to resize the spotlight indicator on resize
		window.addEventListener('resize', () => {
            this.spotWidth = this.spotlights[0].offsetWidth
			this.indicator.style.width = `${this.spotWidth}px`
			this.indicator.style.left = `${this.spotlights[this.active].offsetLeft}px`
        })

		this.indicator.style.width = `${this.spotWidth}px`

		// Start auto rotation
		this.autoRotate()

		this.ada_liveregion = document.createElement(`div`)
		this.ada_liveregion.classList.add(`u-hiddenVisually`)
		this.ada_liveregion.setAttribute(`aria-live`, `polite`)
		this.ada_liveregion.setAttribute(`aria-atomic`, `true`)
		// add after this.el
		this.el.parentNode.insertBefore(this.ada_liveregion, this.el.nextSibling)
	}

	setActive(idx) {
		this.spotlights.forEach((spotlight) => {
			spotlight.classList.remove('is-active')
			this.ada_removeTabIndex(spotlight.querySelector('.content'))
		})
		const activeSpot = this.spotlights[idx]
		// Add active class to the selected spotlight
		activeSpot.classList.add('is-active')
		this.ada_addTabIndex(activeSpot.querySelector('.content'))
		// Update the indicator position to the left position of the selected spotlight
		this.indicator.style.left = `${activeSpot.offsetLeft}px`

		// if we're paused, update the aria-live region
		if (this.paused) {
			this.ada_liveregion.innerHTML = activeSpot.querySelector(`.content > div`).innerHTML
		}

		this.active = idx
	}

	ada_removeTabIndex(el) {
		// remove element, including children and all focusable elements, from the tab order
		el.setAttribute(`tabindex`, `-1`)
		el.querySelectorAll(`a, button, input, select, textarea, [tabindex]`).forEach((el) => {
			el.setAttribute(`tabindex`, `-1`)
		})
	}

	ada_addTabIndex(el) {
		// add element, including children and all focusable elements, to the tab order
        el.setAttribute(`tabindex`, `0`)
        el.querySelectorAll(`a, button, input, select, textarea, [tabindex]`).forEach((el) => {
            el.setAttribute(`tabindex`, `0`)
        })
	}

	autoRotate() {
		this.timer = null

		if (!this.paused) {
            this.rotateToNext()
		}

		this.timer = setTimeout(() => {
			this.autoRotate()
		}, this.options.autoPause)
	}

	rotateToNext() {
		let idx = this.active + 1
		if (idx >= this.spotlights.length) {
            idx = 0
		}
		this.setActive(idx)
	}
}

export const init = (opts, el) => {
	const settings = moduleSettings.set({
		autoPause: 5000
	}, opts)

	new Spotlight(settings, el)
}